import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HotRankSection() {
  const ranked = [...movies].sort((a, b) => b.views - a.views).slice(0, 10);

  return (
    <section className="py-10 md:py-14 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-5 rounded-full bg-primary-500" />
            <h2 className="text-white text-lg font-semibold">热门排行</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {ranked.map((movie, index) => (
              <Link
                key={movie.id}
                to={`/article/${movie.id}`}
                className="group flex items-center gap-4 p-4 rounded-lg bg-white/[0.02] hover:bg-white/[0.05] border border-white/5 hover:border-primary-500/20 transition-all duration-300"
                title={`${movie.title} - 天美麻花星空影视免费观看`}
              >
                <div className="relative flex-shrink-0">
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                      index < 3
                        ? 'bg-primary-500 text-background-950'
                        : 'bg-white/10 text-foreground-400'
                    }`}
                  >
                    {index + 1}
                  </span>
                </div>
                <img
                  src={movie.coverImage}
                  alt={`${movie.title} 海报`}
                  className="w-12 h-16 rounded object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <h3 className="text-white text-sm font-medium truncate group-hover:text-primary-400 transition-colors">
                    {movie.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-primary-400 text-xs">{movie.rating}</span>
                    <span className="text-foreground-600 text-xs">|</span>
                    <span className="text-foreground-600 text-xs">{movie.category}</span>
                    <span className="text-foreground-600 text-xs">|</span>
                    <span className="text-foreground-600 text-xs">{movie.year}</span>
                  </div>
                </div>
                <div className="hidden sm:flex items-center gap-1 text-foreground-600 text-xs">
                  <i className="ri-eye-line"></i>
                  {movie.views > 10000
                    ? `${(movie.views / 10000).toFixed(0)}万`
                    : movie.views}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}